import { render, staticRenderFns } from "./CommunityHappinessAnnualRankingChart.vue?vue&type=template&id=0c06d0d0&scoped=true&"
import script from "./CommunityHappinessAnnualRankingChart.vue?vue&type=script&lang=js&"
export * from "./CommunityHappinessAnnualRankingChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06d0d0",
  null
  
)

export default component.exports